
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16"}},[_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M0 0h16v16H0z"}}),_c('g',{attrs:{"stroke":"#FFF","stroke-linecap":"round","opacity":".8"}},[_c('path',{attrs:{"stroke-linejoin":"round","d":"M.75 5.377l2.095 3.558 3.727-2.107"}}),_c('path',{attrs:{"d":"M4.348 11.79c.34.417.737.787 1.175 1.099A6 6 0 1 0 3 7.999"}})])])])
      }
    
      }
    